import type { LucideIcon } from 'lucide-react';
import { cn } from '../lib/cn';

export interface EmptyStateProps extends React.HTMLAttributes<HTMLDivElement> {
  icon: LucideIcon;
  title: string;
  /** Uma linha de apoio. Secao 6.11: convida a acao, nao descreve o vazio. */
  description?: string;
  action?: React.ReactNode;
}

export function EmptyState({
  className,
  icon: Icon,
  title,
  description,
  action,
  ...props
}: EmptyStateProps) {
  return (
    <div
      className={cn('flex flex-col items-center gap-3 px-6 py-12 text-center', className)}
      {...props}
    >
      <div className="flex size-12 items-center justify-center rounded-full bg-hover">
        <Icon size={24} strokeWidth={1.5} aria-hidden="true" className="text-tertiary" />
      </div>
      <p className="text-[18px] leading-[1.4] font-bold text-primary">{title}</p>
      {description !== undefined && (
        <p className="max-w-[42ch] text-[13px] text-secondary">{description}</p>
      )}
      {action !== undefined && <div className="mt-1">{action}</div>}
    </div>
  );
}
